import { Button } from "@arcadeai/design-system/components/ui/atoms/button";
import { ShieldCheck } from "lucide-react";
import { type ComponentPropsWithoutRef, forwardRef } from "react";

type OAuthActionButtonProps = Omit<
  ComponentPropsWithoutRef<typeof Button>,
  "children"
> & {
  showLabel?: boolean;
};

export const OAuthActionButton = forwardRef<
  HTMLButtonElement,
  OAuthActionButtonProps
>(({ variant = "default", size = "sm", showLabel = true, ...props }, ref) => (
  <Button className="gap-2" ref={ref} size={size} variant={variant} {...props}>
    <ShieldCheck className="size-4" />
    {!!showLabel && <span className="hidden md:inline">Authenticate</span>}
  </Button>
));

OAuthActionButton.displayName = "OAuthActionButton";
